// src/components/ChangePassword.js
import React, { useState } from "react";
import { API_BASE } from "../services/api";

function ChangePassword({ user, onLogout }) {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    const token = localStorage.getItem("token");
    if (!token) {
      setError("Bạn chưa đăng nhập!");
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/update-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ oldPassword, newPassword, confirmPassword }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message || "Đổi mật khẩu thành công!");
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setError(data.error || "Có lỗi xảy ra khi đổi mật khẩu.");
      }
    } catch (err) {
      setError("Không thể kết nối đến máy chủ. Vui lòng thử lại sau.");
    }
  };

  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <div
      className="card"
      style={{ maxWidth: 400, margin: "20px auto", padding: "24px" }}
    >
      <h3>🔑 Đổi mật khẩu</h3>
      <p style={{ fontSize: "14px", color: "#64748b" }}>
        Xin chào, {user?.full_name || "User"}!
      </p>

      {message && (
        <div
          className="notification"
          style={{ background: "#d1fae5", color: "#065f46" }}
        >
          {message}
        </div>
      )}
      {error && (
        <div
          className="notification"
          style={{ background: "#fee2e2", color: "#991b1b" }}
        >
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "12px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "4px",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Mật khẩu cũ
          </label>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type={showPassword ? "text" : "password"}
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="Nhập mật khẩu hiện tại"
              className="input-full"
              required
              style={{ flex: 1 }}
            />
            <button
              type="button"
              onClick={toggleShowPassword}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                padding: "0 8px",
              }}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        <div style={{ marginBottom: "12px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "4px",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Mật khẩu mới
          </label>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type={showPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Nhập mật khẩu mới (ít nhất 6 ký tự)"
              className="input-full"
              required
              minLength="6"
              style={{ flex: 1 }}
            />
            <button
              type="button"
              onClick={toggleShowPassword}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                padding: "0 8px",
              }}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "4px",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Xác nhận mật khẩu mới
          </label>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type={showPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Nhập lại mật khẩu mới"
              className="input-full"
              required
              minLength="6"
              style={{ flex: 1 }}
            />
            <button
              type="button"
              onClick={toggleShowPassword}
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                padding: "0 8px",
              }}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        <button type="submit" className="btn-add" style={{ width: "100%" }}>
          Cập nhật mật khẩu
        </button>
      </form>
    </div>
  );
}

export default ChangePassword;
